module.exports = __webpack_public_path__ + "img/Vinjeboka_Svartebok_fra_Jeloya.cf9682e0.jpg";